import React, { useState, useEffect, useRef, useMemo } from "react";
import {
  Card,
  Typography,
  Form,
  Input,
  Select,
  Row,
  Col,
  Empty,
  Button,
  InputNumber,
  message,
  Spin,
  Switch,
} from "antd";

import {
  BackwardOutlined,
  FormOutlined,
  RetweetOutlined,
} from "@ant-design/icons";
import { useSelector } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import "../courseStyles.css";

import axiosInstance from "../../../../api/Axios";
import {
  COURSE_ID_FIELD,
  COURSE_NAME_FIELD,
  FormInputEdit,
} from "../courseForm";
const { Title, Paragraph } = Typography;
const { Option } = Select;

const CourseSummary = ({ data1, loading, LoadUser, ImpersonateAccess }) => {
  const location = useLocation();
  const isCAAdmin = location.pathname.includes("ca-admin");
  const userInfo = useSelector((state) => state.user);
  const history = useNavigate();
  const { id } = useParams();
  const [messageApi, contextHolder] = message.useMessage();
  const [courseType, setCourseType] = useState("Virtual");
  const [filterOptions, setFilterOptions] = useState({
    categories: [],
    producers: [],
    certificates: [],
    modes: [],
    languages: [],
    ownersList: [],
  });
  const { categories, producers, certificates, modes, languages, ownersList } =
    filterOptions;

  const [selectedCategory, setSelectedCategory] = useState(null);
  const [selectedSubCategory, setSelectedSubCategory] = useState(null);
  const topCategories = categories.map((cat) => ({
    label: cat.name,
    value: cat.id,
  }));
  const subCategories = useMemo(() => {
    if (!selectedCategory) return [];
    const category = categories.find((cat) => cat.id === selectedCategory);
    return (
      category?.second_categories?.map((sub) => ({
        label: sub.name,
        value: sub.id,
      })) || []
    );
  }, [selectedCategory, categories]);

  const updateFilterOption = (key, value) => {
    setFilterOptions((prev) => ({ ...prev, [key]: value }));
  };

  useEffect(() => {
    const LoadFilters = async () => {
      try {
        const res = await axiosInstance.get(
          `/filter/?organization=${userInfo?.data?.organization?.id}`
        );
        updateFilterOption("categories", res?.data?.categories);
      } catch (err) {
        console.log(err);
      }
    };
    const LoadFilters2 = async () => {
      try {
        const res = await axiosInstance.get(`/producerlist/`);
        updateFilterOption("producers", res?.data || []);
      } catch (err) {
        console.log(err);
      }
    };
    const LoadFilters3 = async () => {
      try {
        const res = await axiosInstance.get(`options/certificate_type/`);
        updateFilterOption("certificates", res?.data?.certificate_type || []);
      } catch (err) {
        console.log(err);
      }
    };
    const LoadFilters4 = async () => {
      try {
        const res = await axiosInstance.get(`learn/modes/`);
        updateFilterOption("modes", res?.data || []);
      } catch (err) {
        console.log(err);
      }
    };

    const LoadFilters5 = async () => {
      try {
        const res = await axiosInstance.get(`learn/languages/`);
        updateFilterOption("languages", res?.data || []);
      } catch (err) {
        console.log(err);
      }
    };
    const LoadFilters6 = async () => {
      try {
        const res = await axiosInstance.get(
          `organizationlist/?page=1&page_size=200&status=True&application=5`
        );
        updateFilterOption("ownersList", res?.data?.results || []);
      } catch (err) {
        console.log(err);
      }
    };
    LoadFilters();
    LoadFilters2();
    LoadFilters3();
    LoadFilters4();
    LoadFilters5();
    if (!isCAAdmin) {
      LoadFilters6();
    }
  }, [userInfo?.data?.organization?.id, isCAAdmin]);
  function getCookie(name) {
    const cookies = document.cookie.split("; ");
    for (let i = 0; i < cookies.length; i++) {
      const [cookieName, cookieValue] = cookies[i].split("=");
      if (cookieName === name) {
        return cookieValue;
      }
    }
    return null;
  }
  const csrfToken = getCookie("csrftoken");
  const handleSubmit = async (values) => {
    const normalizedValues = Object.fromEntries(
      Object.entries(values).filter(
        ([key, value]) => value !== null && value !== undefined
      )
    );
    const { duration, duration_type, ...rest } = normalizedValues;

    const formattedDuration =
      duration && duration_type ? `${duration} ${duration_type}` : null;

    const finalValues = {
      ...rest,
      duration: formattedDuration,
      organization: userInfo?.data?.organization?.id,
    };

    console.log("Form submitted with values:", finalValues);
    try {
      const res = await axiosInstance.put(
        `/courseedit/?id=${id}`,
        finalValues,
        {
          headers: {
            "X-CSRFToken": csrfToken,
          },
        }
      );
      CreateSuccessfull(res.data.id);
    } catch (err) {
      CreateFailed();
    }
  };

  const CreateSuccessfull = (id) => {
    messageApi.open({
      type: "success",
      content: "Course edit success.",
      duration: 5,
    });
    LoadUser();
    // setTimeout(() => {
    //   history(`/ca-admin/trainery-learn/courses/listing`);
    // }, 4000);
  };

  const CreateFailed = () => {
    messageApi.open({
      type: "error",
      content: "Course edit failure",
      duration: 5,
    });
  };
  const formRef = useRef();

  const loadForm = React.useCallback(() => {
    if (!loading && formRef.current) {
      let durationValue = "";
      let durationType = "";

      if (data1?.duration) {
        const parts = data1.duration.trim().split(" ");
        durationValue = parts[0]; // e.g. "32"
        durationType = parts[1]; // e.g. "mins" or "hours"
      }
      console.log(
        durationType,
        durationValue,
        data1?.duration,
        "durationValue"
      );
      const formValues = {
        mode: data1?.mode,
        language: data1?.language,
        name: data1?.name,
        course_id: data1?.course_id,
        cpe: data1?.cpe,
        duration: durationValue,
        duration_type: durationType,
        type: data1?.type,
        license: data1?.license,
        description: data1?.description,
        image_url: data1?.image_url,
        category: data1?.category?.id,
        sub_category: data1?.sub_category?.id,
        max_sessions: data1?.max_sessions,
        producer: data1?.producer || null,
        certificate_type: data1?.certificate_type,
        ilt_enabled: data1?.ilt_enabled || false,
        year: data1?.year || null,
        version: data1?.version || null,
        client_owned: data1?.client_owned || false,
        owner: data1?.owner || null,
      };
      formRef.current.setFieldsValue(formValues);
      setCourseType(data1?.mode);
      // setSelectedCategory(data1?.category); // now name
      // setSelectedSubCategory(data1?.sub_category); // now name
    }
  }, [loading, data1]);

  const handleReset = () => {
    loadForm();
  };
  useEffect(() => {
    if (!loading && formRef.current) {
      loadForm();
    }
  }, [loading, data1, loadForm]);
  useEffect(() => {
    if (!data1) return;

    const mapped = categories.map((cat) => ({
      label: cat.name,
      value: cat.id,
      second_categories: cat.second_categories,
    }));

    const categoryObj = mapped.find(
      (cat) => cat.label.toLowerCase() === data1.category?.toLowerCase()
    );

    if (categoryObj) {
      setSelectedCategory(categoryObj.value);
      formRef.current?.setFieldValue("category", categoryObj.value);

      const subCat = categoryObj.second_categories?.find(
        (sc) => sc.name.toLowerCase() === data1.sub_category?.toLowerCase()
      );
      if (subCat) {
        setSelectedSubCategory(subCat.id);
        formRef.current?.setFieldValue("sub_category", subCat.id);
      }
    }
  }, [data1, categories]); // ✅ categories is the real source

  return (
    <Card
      style={{
        width: "100%",
        marginBottom: "10px",
      }}
      hoverable
    >
      <Spin spinning={loading}>
        {contextHolder}
        <Title level={4} style={{ letterSpacing: "0.5px" }}>
          Course Information
        </Title>
        <Paragraph type="secondary">
          Edit and configure your existing course with the details below
        </Paragraph>

        <Form
          layout="vertical"
          onFinish={handleSubmit}
          name="complex-form"
          ref={formRef}
          disabled={!ImpersonateAccess || (isCAAdmin && !data1?.can_edit)}
        >
          <Row gutter={16}>
            <Col span={6}>
              <Form.Item
                label="Mode of Course"
                required
                rules={[
                  {
                    required: true,
                    message: "Course mode is required",
                  },
                ]}
                name="mode"
                initialValue="Virtual"
              >
                <Select
                  value={courseType}
                  onChange={(value) => setCourseType(value)}
                  disabled
                >
                  {modes.map((mode) => (
                    <Option key={mode} value={mode}>
                      {mode}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>

            <FormInputEdit
              field={COURSE_NAME_FIELD}
              initialValue={data1?.name}
              text={"course_name"}
            />

            <FormInputEdit
              field={{ ...COURSE_ID_FIELD, span: 6 }}
              initialValue={data1?.course_id}
              text={"course_id"}
            />
          </Row>
          <Row gutter={16}>
            <Col span={9}>
              <Form.Item
                label="Category"
                name="category"
                required
                rules={[
                  {
                    required: true,
                    message: "Category is required",
                  },
                ]}
              >
                <Select
                  placeholder="Select category"
                  showSearch
                  filterOption={(input, option) =>
                    option?.label.toLowerCase().includes(input.toLowerCase())
                  }
                  onChange={(value) => {
                    setSelectedCategory(value);
                    setSelectedSubCategory(null);

                    formRef.current?.setFieldValue("sub_category", null);
                  }}
                  options={topCategories}
                  allowClear
                />
              </Form.Item>
            </Col>

            <Col span={9}>
              <Form.Item label="Sub Category" name="sub_category">
                <Select
                  placeholder="Select subcategory"
                  value={selectedSubCategory}
                  onChange={(value) => setSelectedSubCategory(value)}
                  options={subCategories}
                  disabled={
                    !selectedCategory ||
                    !ImpersonateAccess ||
                    (isCAAdmin && !data1?.can_edit)
                  }
                  notFoundContent={selectedCategory ? <Empty /> : null}
                  allowClear
                />
              </Form.Item>
            </Col>
            <Col span={6}>
              <Form.Item
                label="Language"
                required
                rules={[
                  {
                    required: true,
                    message: "language is required",
                  },
                ]}
                name="language"
                initialValue="English"
              >
                <Select>
                  {languages.map((mode) => (
                    <Option key={mode} value={mode}>
                      {mode}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
          </Row>
          {courseType === "Virtual" && (
            <>
              <Row gutter={16}>
                <Col span={7}>
                  <Form.Item label="Course CPE" name="cpe">
                    <InputNumber
                      placeholder="Enter CPE credits"
                      style={{ width: "100%" }}
                      min={0}
                      parser={(value) => value.replace(/[^\d.]/g, "")}
                    />
                  </Form.Item>
                </Col>
                <Col span={7}>
                  <Form.Item label="Duration">
                    <Input.Group compact>
                      <Form.Item
                        name="duration"
                        noStyle
                        rules={[
                          {
                            required: true,
                            message: "Please enter duration",
                          },
                        ]}
                      >
                        <Input
                          style={{ width: "60%" }}
                          placeholder="Enter number"
                        />
                      </Form.Item>

                      <Form.Item
                        name="duration_type"
                        noStyle
                        initialValue="mins"
                        rules={[
                          {
                            required: true,
                            message: "Please select type",
                          },
                        ]}
                      >
                        <Select style={{ width: "40%" }}>
                          <Option value="mins">Mins</Option>
                          <Option value="hours">Hours</Option>
                        </Select>
                      </Form.Item>
                    </Input.Group>
                  </Form.Item>
                </Col>

                <Col span={6}>
                  <Form.Item label="Type" name="type" initialValue="Training">
                    <Select>
                      <Option value="Training">Training</Option>
                      <Option value="Certification">Certification</Option>
                    </Select>
                  </Form.Item>
                </Col>
                <Col span={4}>
                  <Form.Item
                    label="Certificate"
                    name="license"
                    required
                    rules={[
                      {
                        required: true,
                        message: "Certificate is required",
                      },
                    ]}
                  >
                    <Select placeholder="Select">
                      <Option value={true}>Yes</Option>
                      <Option value={false}>No</Option>
                    </Select>
                  </Form.Item>
                </Col>
              </Row>
            </>
          )}
          {courseType === "Onsite" && (
            <>
              <Row gutter={16}>
                <Col span={9}>
                  <Form.Item
                    label="No. Of Sessions"
                    required
                    rules={[
                      {
                        required: true,
                        message: "Sessions is required",
                      },
                    ]}
                    name="max_sessions"
                  >
                    <Input placeholder="Enter Number" />
                  </Form.Item>
                </Col>
              </Row>
            </>
          )}
          {courseType === "E-Learning" && (
            <>
              <Row gutter={16}>
                <Col span={9}>
                  <Form.Item label="Course Certificate" name="certificate_type">
                    <Select
                      placeholder="Select Certificate"
                      style={{ width: "100%" }}
                      allowClear
                      showSearch
                      optionFilterProp="children"
                    >
                      {certificates?.map((cert) => (
                        <Option key={cert} value={cert}>
                          {cert}
                        </Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>
                {!isCAAdmin && (
                  <Col span={9}>
                    <Form.Item label="Producer" name="producer">
                      <Select
                        placeholder="Select Producer"
                        style={{ width: "100%" }}
                        allowClear
                        showSearch
                        optionFilterProp="children"
                      >
                        {producers?.map((producer) => (
                          <Option key={producer.id} value={producer.id}>
                            {producer?.name}
                          </Option>
                        ))}
                      </Select>
                    </Form.Item>
                  </Col>
                )}
                <Col span={6}>
                  <Form.Item label="Course CPE" name="cpe">
                    <InputNumber
                      placeholder="Enter CPE credits"
                      style={{ width: "100%" }}
                      min={0}
                      parser={(value) => value.replace(/[^\d.]/g, "")}
                    />
                  </Form.Item>
                </Col>
              </Row>
              <Row gutter={16}>
                <Col span={9}>
                  <Form.Item label="Duration" required>
                    <Input.Group compact>
                      <Form.Item
                        name="duration"
                        noStyle
                        rules={[
                          {
                            required: true,
                            message: "Please enter duration",
                          },
                        ]}
                      >
                        <Input
                          style={{ width: "60%" }}
                          placeholder="Enter number"
                        />
                      </Form.Item>

                      <Form.Item
                        name="duration_type"
                        noStyle
                        initialValue="mins"
                        rules={[
                          {
                            required: true,
                            message: "Please select type",
                          },
                        ]}
                      >
                        <Select style={{ width: "40%" }}>
                          <Option value="mins">Mins</Option>
                          <Option value="hours">Hours</Option>
                        </Select>
                      </Form.Item>
                    </Input.Group>
                  </Form.Item>
                </Col>
                <Col span={4}>
                  <Form.Item label="Course Version" name="version">
                    <InputNumber
                      placeholder="Enter Version"
                      style={{ width: "100%" }}
                      min={0}
                    />
                  </Form.Item>
                </Col>
                <Col span={3}>
                  <Form.Item
                    label="Year"
                    name="year"
                    rules={[
                      {
                        validator: (_, value) => {
                          if (!value)
                            return Promise.reject("Please enter a year");

                          const str = value.toString();
                          if (str.length !== 4)
                            return Promise.reject("Enter a 4-digit year");

                          if (value < 1980 || value > 2100)
                            return Promise.reject(
                              "Year must be between 1980 and 2100"
                            );

                          return Promise.resolve();
                        },
                      },
                    ]}
                  >
                    <InputNumber
                      placeholder="YYYY"
                      style={{ width: "100%" }}
                      min={1980}
                      max={2100}
                    />
                  </Form.Item>
                </Col>
              </Row>
            </>
          )}
          {!isCAAdmin && (
            <>
              <Row gutter={16}>
                <Col span={3}>
                  <Form.Item
                    label="Client Owned"
                    name="client_owned"
                    valuePropName="checked"
                    initialValue={false}
                  >
                    <Switch checkedChildren="Yes" unCheckedChildren="No" />
                  </Form.Item>
                </Col>

                <Form.Item
                  noStyle
                  shouldUpdate={(prev, curr) =>
                    prev.client_owned !== curr.client_owned
                  }
                >
                  {({ getFieldValue }) => {
                    const showOwner = getFieldValue("client_owned");
                    return showOwner ? (
                      <Col span={8}>
                        <Form.Item
                          label="Client Owner"
                          name="owner"
                          rules={[
                            {
                              required: true,
                              message: "Please select an owner",
                            },
                          ]}
                        >
                          <Select
                            placeholder="Select Owner"
                            showSearch
                            optionFilterProp="children"
                            options={ownersList.map((owner) => ({
                              label: owner.name,
                              value: owner.id,
                            }))}
                          />
                        </Form.Item>
                      </Col>
                    ) : null;
                  }}
                </Form.Item>
              </Row>
            </>
          )}
          <Row gutter={16}>
            <Col span={24}>
              <Form.Item label="Course Description" name="description">
                <Input.TextArea rows={4} placeholder="Enter description" />
              </Form.Item>
            </Col>
          </Row>

          <div
            className="group-1-box"
            style={{
              paddingTop: "0rem",
              paddingLeft: "0px",
              display: "flex",
              justifyContent: "space-between",
              width: "100%",
            }}
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
                marginLeft: "10px",
              }}
            >
              <span
                style={{
                  marginRight: "10px",
                  fontWeight: 500,
                  fontSize: "14.75px",
                }}
              >
                ILT Enabled :
              </span>
              <Form.Item
                name="ilt_enabled"
                initialValue={false}
                valuePropName="checked"
                style={{ marginBottom: 0 }}
              >
                <Switch size="medium" />
              </Form.Item>
            </div>
            <div>
              <div style={{ display: "inline-block" }}>
                <Form.Item label=" " colon={false}>
                  <Button
                    type="text"
                    htmlType="button"
                    style={{
                      background: "#D3D3D3",
                    }}
                    onClick={() => {
                      history(
                        isCAAdmin
                          ? "/ca-admin/trainery-learn/courses/listing"
                          : "/trainery-learn/courses/listing"
                      );
                    }}
                  >
                    <BackwardOutlined />
                    Back
                  </Button>
                </Form.Item>
              </div>

              <div style={{ display: "inline-block", marginLeft: "16px" }}>
                <Form.Item label=" " colon={false}>
                  <Button
                    type="primary"
                    htmlType="submit"
                    className="save-update-btn"
                    // style={{
                    //   background: "#f58029",
                    // }}
                  >
                    Update
                    <FormOutlined />
                  </Button>
                </Form.Item>
              </div>
              <div style={{ display: "inline-block", marginLeft: "16px" }}>
                <Form.Item label=" " colon={false}>
                  <Button
                    type="text"
                    htmlType="button"
                    onClick={handleReset}
                    style={{
                      background: "#D3D3D3",
                    }}
                  >
                    Reset
                    <RetweetOutlined />
                  </Button>
                </Form.Item>
              </div>
            </div>
          </div>
        </Form>
      </Spin>
    </Card>
  );
};

export default CourseSummary;
